import cn from 'classnames';
import { Button, BUTTON_THEMES } from 'ht-styleguide';
import styles from '../plansPage.module.scss';

type ChoosePlanBlockProps = {
  title?: string;
  text?: string;
  buttonText?: string;
};

const ChoosePlanBlock = ({
  title = 'We’ve got you covered',
  text = 'Get complete support for all of your connected devices',
  buttonText = 'See Memberships',
}: ChoosePlanBlockProps) => (
  <div className={styles.chooseAPlanOuterContainer}>
    <section className={styles.chooseAPlanContainer}>
      <h3 className={styles.title}>{title}</h3>
      <p className={cn('p0', styles.chooseAPlanText)}>{text}</p>
      <div className={styles.chooseAPlanButton}>
        <Button
          theme={BUTTON_THEMES.INVERTED}
          onClick={() => {
            window.scrollTo({
              top: 350,
              behavior: 'smooth',
            });
          }}
        >
          {buttonText}
        </Button>
      </div>
    </section>
  </div>
);

export default ChoosePlanBlock;
